import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {HsaObject} from '../../../../../../types/HsaObject';
import {CareproviderUnitService} from '../../../../../../services/careprovider-unit.service';

@Component({
  selector: 'app-cpru-related',
  templateUrl: './cpru-related.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class CpruRelatedComponent {
  private careproviderUnitService = inject(CareproviderUnitService);
  protected careproviderUnit = this.careproviderUnitService.careproviderUnit;

  public businessClassificationsString = computed<string>(() => {
    const businessClassifications: string[] = [];
    if (
      this.careproviderUnit() &&
      this.careproviderUnit().hsaObjects &&
      this.careproviderUnit().hsaObjects.length > 0
    ) {
      this.careproviderUnit().hsaObjects.forEach((hsaObject: HsaObject) => {
        if (hsaObject.hsaBusinessClassifications && hsaObject.hsaBusinessClassifications.length > 0) {
          hsaObject.hsaBusinessClassifications.forEach((businessClassification) => {
            if (!businessClassifications.includes(businessClassification.name)) {
              businessClassifications.push(businessClassification.name);
            }
          });
        }
      });
    }
    return businessClassifications.length > 0 ? businessClassifications.join(', ') : '';
  });
}
